import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Project, ProjectFactory, Campaign } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Markdown } from '@independent-software/typeui/formatters/Markdown';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { ListCampaigns } from '../Campaign';
import { Label } from '@independent-software/typeui/controls/Label';
import { Output } from '../../controls/Output';

class ViewProject extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/projects/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("Project deleted.");
    this.props.history.push('/projects');
  }    

  private handleCampaignClick = (item:Campaign) => {
    this.props.history.push(`/campaigns/${item.id}`);
  }    

  render() {
    let p = this.props;
    return (
      <Viewer<Project> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={ProjectFactory}
        canEdit='can_edit_projects'
        canDelete='can_delete_projects'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(project: Project) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1">{project.name}</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="Data">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <>
                      <Output label="Name" hint="Project name">{project.name}</Output>
                      <Output label="Reference" hint="Project reference">{project.reference}</Output>
                      <Output label="Agency" hint="Funding agency">{project.agency}</Output>
                      <Output label="Manager" hint="Data manager">{project.manager}</Output>
                      <Output label="Contact" hint="Contact information">{project.contact}</Output>
                    </>
                    <Output label="Description" hint="Project description"><Markdown source={project.description}/></Output>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>
              <Tabs.Pane label={<span>Campaigns <Label size="small">{project.campaigns_count}</Label></span>}>
                <ListCampaigns auth={p.auth} name="projects_campaigns" projectId={project.id} onClick={this.handleCampaignClick}/>
              </Tabs.Pane>                  
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewProject };
